// List of countries with their ISO code and continent.
// Continents match the values used by the continent filter:
// Africa, Asia, Europe, North America, Oceania, South America.
// (A handful of sub-Antarctic territories are tagged 'Antarctica' and are
// therefore never matched by the continent filter, which is intentional.)
export const countries = [
  { name: 'Afghanistan', code: 'AF', continent: 'Asia' },
  { name: 'Åland Islands', code: 'AX', continent: 'Europe' },
  { name: 'Albania', code: 'AL', continent: 'Europe' },
  { name: 'Algeria', code: 'DZ', continent: 'Africa' },
  { name: 'America', code: 'AS', continent: 'Oceania' },
  { name: 'American Minor Outlying Islands', code: 'UM', continent: 'Oceania' },
  { name: 'American Virgin Islands', code: 'VI', continent: 'North America' },
  { name: 'Andorra', code: 'AD', continent: 'Europe' },
  { name: 'Angola', code: 'AO', continent: 'Africa' },
  { name: 'Anguilla', code: 'AI', continent: 'North America' },
  { name: 'Antarctica', code: 'AQ', continent: 'Antarctica' },
  { name: 'Antigua and Barbuda', code: 'AG', continent: 'North America' },
  { name: 'Argentina', code: 'AR', continent: 'South America' },
  { name: 'Armenia', code: 'AM', continent: 'Asia' },
  { name: 'Aruba', code: 'AW', continent: 'North America' },
  { name: 'Australia', code: 'AU', continent: 'Oceania' },
  { name: 'Austria', code: 'AT', continent: 'Europe' },
  { name: 'Azerbaijan', code: 'AZ', continent: 'Asia' },
  { name: 'Bahamas', code: 'BS', continent: 'North America' },
  { name: 'Bahrain', code: 'BH', continent: 'Asia' },
  { name: 'Bangladesh', code: 'BD', continent: 'Asia' },
  { name: 'Barbados', code: 'BB', continent: 'North America' },
  { name: 'Belarus', code: 'BY', continent: 'Europe' },
  { name: 'Belgium', code: 'BE', continent: 'Europe' },
  { name: 'Belize', code: 'BZ', continent: 'North America' },
  { name: 'Benin', code: 'BJ', continent: 'Africa' },
  { name: 'Bermuda', code: 'BM', continent: 'North America' },
  { name: 'Bhutan', code: 'BT', continent: 'Asia' },
  { name: 'Bolivia', code: 'BO', continent: 'South America' },
  { name: 'Bosnia and Herzegovina', code: 'BA', continent: 'Europe' },
  { name: 'Botswana', code: 'BW', continent: 'Africa' },
  { name: 'Bouvet Islands', code: 'BV', continent: 'Antarctica' },
  { name: 'Brazil', code: 'BR', continent: 'South America' },
  { name: 'British Indian Ocean Territory', code: 'IO', continent: 'Asia' },
  { name: 'British Virgin Islands', code: 'VG', continent: 'North America' },
  { name: 'Brunei Darussalam', code: 'BN', continent: 'Asia' },
  { name: 'Bulgaria', code: 'BG', continent: 'Europe' },
  { name: 'Burkina Faso', code: 'BF', continent: 'Africa' },
  { name: 'Burma', code: 'MM', continent: 'Asia' },
  { name: 'Burundi', code: 'BI', continent: 'Africa' },
  { name: 'Cambodia', code: 'KH', continent: 'Asia' },
  { name: 'Cameroon', code: 'CM', continent: 'Africa' },
  { name: 'Canada', code: 'CA', continent: 'North America' },
  { name: 'Cape Verde', code: 'CV', continent: 'Africa' },
  { name: 'Cayman Islands', code: 'KY', continent: 'North America' },
  { name: 'Central African Republic', code: 'CF', continent: 'Africa' },
  { name: 'Chad', code: 'TD', continent: 'Africa' },
  { name: 'Chile', code: 'CL', continent: 'South America' },
  { name: 'China', code: 'CN', continent: 'Asia' },
  { name: 'Christmas Island', code: 'CX', continent: 'Oceania' },
  { name: 'Coconut Islands', code: 'CC', continent: 'Oceania' },
  { name: 'Colombia', code: 'CO', continent: 'South America' },
  { name: 'Comoros', code: 'KM', continent: 'Africa' },
  { name: 'Cook Islands', code: 'CK', continent: 'Oceania' },
  { name: 'Costa Rica', code: 'CR', continent: 'North America' },
  { name: "Côte d'Ivoire", code: 'CI', continent: 'Africa' },
  { name: 'Croatia', code: 'HR', continent: 'Europe' },
  { name: 'Cuba', code: 'CU', continent: 'North America' },
  { name: 'Curaçao', code: 'CW', continent: 'North America' },
  { name: 'Cyprus', code: 'CY', continent: 'Asia' },
  { name: 'Czech Republic', code: 'CZ', continent: 'Europe' },
  { name: 'Democratic Republic of the Congo', code: 'CD', continent: 'Africa' },
  { name: 'Denmark', code: 'DK', continent: 'Europe' },
  { name: 'Djibouti', code: 'DJ', continent: 'Africa' },
  { name: 'Dominica', code: 'DM', continent: 'North America' },
  { name: 'Dominican Republic', code: 'DO', continent: 'North America' },
  { name: 'East Timor', code: 'TL', continent: 'Asia' },
  { name: 'East Timor (deprecated)', code: 'TP', continent: 'Asia' },
  { name: 'Ecuador', code: 'EC', continent: 'South America' },
  { name: 'Egypt', code: 'EG', continent: 'Africa' },
  { name: 'El Salvador', code: 'SV', continent: 'North America' },
  { name: 'Equatorial Guinea', code: 'GQ', continent: 'Africa' },
  { name: 'Eritrea', code: 'ER', continent: 'Africa' },
  { name: 'Estonia', code: 'EE', continent: 'Europe' },
  { name: 'Ethiopia', code: 'ET', continent: 'Africa' },
  { name: 'Falkland Islands', code: 'FK', continent: 'South America' },
  { name: 'Faroe Islands', code: 'FO', continent: 'Europe' },
  { name: 'Fiji', code: 'FJ', continent: 'Oceania' },
  { name: 'Finland', code: 'FI', continent: 'Europe' },
  { name: 'France', code: 'FR', continent: 'Europe' },
  { name: 'French Guyana', code: 'GF', continent: 'South America' },
  { name: 'French Polynesia', code: 'PF', continent: 'Oceania' },
  { name: 'French Southern and Antarctic Lands', code: 'TF', continent: 'Antarctica' },
  { name: 'Gabon', code: 'GA', continent: 'Africa' },
  { name: 'Gambia', code: 'GM', continent: 'Africa' },
  { name: 'Georgia', code: 'GE', continent: 'Asia' },
  { name: 'Germany', code: 'DE', continent: 'Europe' },
  { name: 'Ghana', code: 'GH', continent: 'Africa' },
  { name: 'Gibraltar', code: 'GI', continent: 'Europe' },
  { name: 'Greece', code: 'GR', continent: 'Europe' },
  { name: 'Greenland', code: 'GL', continent: 'North America' },
  { name: 'Grenada', code: 'GD', continent: 'North America' },
  { name: 'Guadeloupe', code: 'GP', continent: 'North America' },
  { name: 'Guam', code: 'GU', continent: 'Oceania' },
  { name: 'Guernsey (Channel Islands)', code: 'GG', continent: 'Europe' },
  { name: 'Guinea', code: 'GN', continent: 'Africa' },
  { name: 'Guinea-Bissau', code: 'GW', continent: 'Africa' },
  { name: 'Guyana', code: 'GY', continent: 'South America' },
  { name: 'Haiti', code: 'HT', continent: 'North America' },
  { name: 'Heard and McDonald Islands', code: 'HM', continent: 'Antarctica' },
  { name: 'Honduras', code: 'HN', continent: 'North America' },
  { name: 'Hong Kong', code: 'HK', continent: 'Asia' },
  { name: 'Hungary', code: 'HU', continent: 'Europe' },
  { name: 'Iceland', code: 'IS', continent: 'Europe' },
  { name: 'India', code: 'IN', continent: 'Asia' },
  { name: 'Indonesia', code: 'ID', continent: 'Asia' },
  { name: 'Iran', code: 'IR', continent: 'Asia' },
  { name: 'Iraq', code: 'IQ', continent: 'Asia' },
  { name: 'Ireland', code: 'IE', continent: 'Europe' },
  { name: 'Isle of Man', code: 'IM', continent: 'Europe' },
  { name: 'Israel', code: 'IL', continent: 'Asia' },
  { name: 'Italy', code: 'IT', continent: 'Europe' },
  { name: 'Jamaica', code: 'JM', continent: 'North America' },
  { name: 'Japan', code: 'JP', continent: 'Asia' },
  { name: 'Jersey', code: 'JE', continent: 'Europe' },
  { name: 'Jordan', code: 'JO', continent: 'Asia' },
  { name: 'Kazakhstan', code: 'KZ', continent: 'Asia' },
  { name: 'Kenya', code: 'KE', continent: 'Africa' },
  { name: 'Kiribati', code: 'KI', continent: 'Oceania' },
  { name: 'Kuwait', code: 'KW', continent: 'Asia' },
  { name: 'Kyrgyzstan', code: 'KG', continent: 'Asia' },
  { name: 'Laos', code: 'LA', continent: 'Asia' },
  { name: 'Latvia', code: 'LV', continent: 'Europe' },
  { name: 'Lebanon', code: 'LB', continent: 'Asia' },
  { name: 'Lesotho', code: 'LS', continent: 'Africa' },
  { name: 'Liberia', code: 'LR', continent: 'Africa' },
  { name: 'Libya', code: 'LY', continent: 'Africa' },
  { name: 'Liechtenstein', code: 'LI', continent: 'Europe' },
  { name: 'Lithuania', code: 'LT', continent: 'Europe' },
  { name: 'Luxembourg', code: 'LU', continent: 'Europe' },
  { name: 'Macau', code: 'MO', continent: 'Asia' },
  { name: 'Macedonia', code: 'MK', continent: 'Europe' },
  { name: 'Madagascar', code: 'MG', continent: 'Africa' },
  { name: 'Malawi', code: 'MW', continent: 'Africa' },
  { name: 'Malaysia', code: 'MY', continent: 'Asia' },
  { name: 'Maldives', code: 'MV', continent: 'Asia' },
  { name: 'Mali', code: 'ML', continent: 'Africa' },
  { name: 'Malta', code: 'MT', continent: 'Europe' },
  { name: 'Marshall Islands', code: 'MH', continent: 'Oceania' },
  { name: 'Martinique', code: 'MQ', continent: 'North America' },
  { name: 'Mauritania', code: 'MR', continent: 'Africa' },
  { name: 'Mauritius', code: 'MU', continent: 'Africa' },
  { name: 'Mayotte', code: 'YT', continent: 'Africa' },
  { name: 'Mexico', code: 'MX', continent: 'North America' },
  { name: 'Micronesia', code: 'FM', continent: 'Oceania' },
  { name: 'Moldova', code: 'MD', continent: 'Europe' },
  { name: 'Monaco', code: 'MC', continent: 'Europe' },
  { name: 'Mongolia', code: 'MN', continent: 'Asia' },
  { name: 'Montenegro', code: 'ME', continent: 'Europe' },
  { name: 'Montserrat', code: 'MS', continent: 'North America' },
  { name: 'Morocco', code: 'MA', continent: 'Africa' },
  { name: 'Mozambique', code: 'MZ', continent: 'Africa' },
  { name: 'Namibia', code: 'NA', continent: 'Africa' },
  { name: 'Nauru', code: 'NR', continent: 'Oceania' },
  { name: 'Nepal', code: 'NP', continent: 'Asia' },
  { name: 'Netherlands', code: 'NL', continent: 'Europe' },
  { name: 'New Caledonia', code: 'NC', continent: 'Oceania' },
  { name: 'New Zealand', code: 'NZ', continent: 'Oceania' },
  { name: 'Nicaragua', code: 'NI', continent: 'North America' },
  { name: 'Niger', code: 'NE', continent: 'Africa' },
  { name: 'Nigeria', code: 'NG', continent: 'Africa' },
  { name: 'Niue', code: 'NU', continent: 'Oceania' },
  { name: 'Norfolk Islands', code: 'NF', continent: 'Oceania' },
  { name: 'North Korea', code: 'KP', continent: 'Asia' },
  { name: 'North Mariana Islands', code: 'MP', continent: 'Oceania' },
  { name: 'Norway', code: 'NO', continent: 'Europe' },
  { name: 'Oman', code: 'OM', continent: 'Asia' },
  { name: 'Pakistan', code: 'PK', continent: 'Asia' },
  { name: 'Palau', code: 'PW', continent: 'Oceania' },
  { name: 'Palestine', code: 'PS', continent: 'Asia' },
  { name: 'Panama', code: 'PA', continent: 'North America' },
  { name: 'Papua New Guinea', code: 'PG', continent: 'Oceania' },
  { name: 'Paraguay', code: 'PY', continent: 'South America' },
  { name: 'Peru', code: 'PE', continent: 'South America' },
  { name: 'Philippines', code: 'PH', continent: 'Asia' },
  { name: 'Pitcairn Islands', code: 'PN', continent: 'Oceania' },
  { name: 'Poland', code: 'PL', continent: 'Europe' },
  { name: 'Portugal', code: 'PT', continent: 'Europe' },
  { name: 'Puerto Rico', code: 'PR', continent: 'North America' },
  { name: 'Qatar', code: 'QA', continent: 'Asia' },
  { name: 'Republic of the Congo', code: 'CG', continent: 'Africa' },
  { name: 'Reunion', code: 'RE', continent: 'Africa' },
  { name: 'Romania', code: 'RO', continent: 'Europe' },
  { name: 'Russian Federation', code: 'RU', continent: 'Europe' },
  { name: 'Rwanda', code: 'RW', continent: 'Africa' },
  { name: 'Saba', code: 'BQ', continent: 'North America' },
  { name: 'Saint Helena', code: 'SH', continent: 'Africa' },
  { name: 'Saint Kitts and Nevis', code: 'KN', continent: 'North America' },
  { name: 'Samoa', code: 'WS', continent: 'Oceania' },
  { name: 'San Marino', code: 'SM', continent: 'Europe' },
  { name: 'Sao Tome and Principe', code: 'ST', continent: 'Africa' },
  { name: 'Saudi Arabia', code: 'SA', continent: 'Asia' },
  { name: 'Senegal', code: 'SN', continent: 'Africa' },
  { name: 'Serbia', code: 'RS', continent: 'Europe' },
  { name: 'Serbia and Montenegro', code: 'CS', continent: 'Europe' },
  { name: 'Seychelles', code: 'SC', continent: 'Africa' },
  { name: 'Sierra Leone', code: 'SL', continent: 'Africa' },
  { name: 'Singapore', code: 'SG', continent: 'Asia' },
  { name: 'Sint Maarten (Dutch part)', code: 'SX', continent: 'North America' },
  { name: 'Slovakia', code: 'SK', continent: 'Europe' },
  { name: 'Slovenia', code: 'SI', continent: 'Europe' },
  { name: 'Solomon Islands', code: 'SB', continent: 'Oceania' },
  { name: 'Somalia', code: 'SO', continent: 'Africa' },
  { name: 'South Africa', code: 'ZA', continent: 'Africa' },
  { name: 'South Georgia and the Southern Sandwich Islands', code: 'GS', continent: 'Antarctica' },
  { name: 'South Korea', code: 'KR', continent: 'Asia' },
  { name: 'South Sudan', code: 'SS', continent: 'Africa' },
  { name: 'Spain', code: 'ES', continent: 'Europe' },
  { name: 'Sri Lanka', code: 'LK', continent: 'Asia' },
  { name: 'St. Lucia', code: 'LC', continent: 'North America' },
  { name: 'Saint Martin (French part)', code: 'MF', continent: 'North America' },
  { name: 'St. Pierre and Miquelon', code: 'PM', continent: 'North America' },
  { name: 'St. Vincent and the Grenadines', code: 'VC', continent: 'North America' },
  { name: 'Sudan', code: 'SD', continent: 'Africa' },
  { name: 'Suriname', code: 'SR', continent: 'South America' },
  { name: 'Svalbard', code: 'SJ', continent: 'Europe' },
  { name: 'Swaziland', code: 'SZ', continent: 'Africa' },
  { name: 'Sweden', code: 'SE', continent: 'Europe' },
  { name: 'Switzerland', code: 'CH', continent: 'Europe' },
  { name: 'Syria', code: 'SY', continent: 'Asia' },
  { name: 'Taiwan', code: 'TW', continent: 'Asia' },
  { name: 'Tajikistan', code: 'TJ', continent: 'Asia' },
  { name: 'Tanzania', code: 'TZ', continent: 'Africa' },
  { name: 'Thailand', code: 'TH', continent: 'Asia' },
  { name: 'Togo', code: 'TG', continent: 'Africa' },
  { name: 'Tokelau Islands', code: 'TK', continent: 'Oceania' },
  { name: 'Tonga', code: 'TO', continent: 'Oceania' },
  { name: 'Trinidad and Tobago', code: 'TT', continent: 'North America' },
  { name: 'Tunisia', code: 'TN', continent: 'Africa' },
  { name: 'Turkey', code: 'TR', continent: 'Asia' },
  { name: 'Turkmenistan', code: 'TM', continent: 'Asia' },
  { name: 'Turks and Caicos Islands', code: 'TC', continent: 'North America' },
  { name: 'Tuvalu', code: 'TV', continent: 'Oceania' },
  { name: 'Uganda', code: 'UG', continent: 'Africa' },
  { name: 'Ukraine', code: 'UA', continent: 'Europe' },
  { name: 'United Arab Emirates', code: 'AE', continent: 'Asia' },
  { name: 'United Kingdom', code: 'GB', continent: 'Europe' },
  { name: 'Uruguay', code: 'UY', continent: 'South America' },
  { name: 'USA', code: 'US', continent: 'North America' },
  { name: 'Uzbekistan', code: 'UZ', continent: 'Asia' },
  { name: 'Vanuatu', code: 'VU', continent: 'Oceania' },
  { name: 'Vatican City', code: 'VA', continent: 'Europe' },
  { name: 'Venezuela', code: 'VE', continent: 'South America' },
  { name: 'Vietnam', code: 'VN', continent: 'Asia' },
  { name: 'Wallis and Futuna Islands', code: 'WF', continent: 'Oceania' },
  { name: 'West Sahara', code: 'EH', continent: 'Africa' },
  { name: 'Yemen', code: 'YE', continent: 'Asia' },
  { name: 'Zambia', code: 'ZM', continent: 'Africa' },
  { name: 'Zimbabwe', code: 'ZW', continent: 'Africa' }
]

export default countries
